import styled from 'styled-components';
import { Row } from 'components/shared/Layout';
import RadioFieldSet from 'components/ui/RadioFieldSet';

import { colours } from 'themes/default';

export const StyledRadioFieldSet = styled(RadioFieldSet)`
  background: ${colours.Shades.TintBlue10};
  padding: 8px;
  margin-bottom: 24px;
`;

export const PaymentContainer = styled(Row)`
  margin-top: 24px;
`;

export const PaymentSummary = styled(Row)`
  height: 100%;
  border-right: solid 1px #333;

  p {
    font-weight: 700;
  }
`;

export const PaymentSelectionContainer = styled.div`
  h2 {
    margin-right: 16px;
    white-space: nowrap;
  }
`;

export const StyledPaymentContainer = styled(Row)`
  padding-left: 24px;
  p {
    margin: 0;
  }
`;

export const StyledAmount = styled.div`
  margin: 0;
  margin-right: 32px;
  h3,
  h4 {
    font-size: 24px;
    font-weight: 400;
    margin: 0;
    margin-bottom: 16px;
  }
  h4 {
    font-size: 18px;
    margin-top: 32px;
  }
`;

export const StyledPayments = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin-top: 0;
`;

export const StyledAmountDue = styled.h3`
  padding-bottom: 24px;
  border-bottom: 1px solid ${colours.Greyscale.SilverGrey};
`;

export const StyledSpacedApart = styled.p`
  display: flex;
  padding-right: 32px;
  justify-content: space-between;
`;

export const Divider = styled.span`
  border-bottom: 1px solid ${colours.Greyscale.SilverGrey};
  flex-grow: 1;
  margin: 0 8px 6px 8px;
`;
